import {
  Component,
  ViewChild,
  ElementRef
} from '@angular/core';

@Component({
  selector: 'app-chat-widget',
  templateUrl: './chat-widget.component.html',
  styleUrls: ['./chat-widget.component.scss'],
  standalone: false
})
export class ChatWidgetComponent {
  open = false;
  newMessage = '';
  messages = [
    { sender: 'student', text: 'السلام عليكم، لدي سؤال حول وحدة الشبكات.', timestamp: new Date('2025-06-10T10:05') },
    { sender: 'teacher', text: 'وعليكم السلام أحمد، تفضل بالسؤال.',            timestamp: new Date('2025-06-10T10:07') },
    { sender: 'student', text: 'ما الفرق بين العنوان الثابت والديناميكي؟',         timestamp: new Date('2025-06-10T10:10') },
    { sender: 'teacher', text: 'العنوان الثابت لا يتغير بعد إعادة التشغيل...',      timestamp: new Date('2025-06-10T10:12') }
  ];

  @ViewChild('chatBody') chatBody!: ElementRef<HTMLElement>;

  toggle() {
    this.open = !this.open;
    if (this.open) setTimeout(() => this.scrollToBottom());
  }

  sendMessage() {
    const text = this.newMessage.trim();
    if (!text) return;
    this.messages.push({ sender: 'student', text, timestamp: new Date() });
    this.newMessage = '';
    setTimeout(() => this.scrollToBottom());
  }

  scrollToBottom() {
    const el = this.chatBody.nativeElement;
    el.scrollTop = el.scrollHeight;
  }
}
